import { styled } from '@mui/material/styles';
import { IconButton, Badge, Avatar, Box } from '@mui/material';
import UpdateProfilePhotoModal from 'components/profile/UpdateProfilePhotoModal';
import { UserType } from 'hooks/useUserData';
import { useState } from 'react';
import Upload2LineIcon from 'remixicon-react/Upload2LineIcon';
import UserLineIcon from 'remixicon-react/UserLineIcon';
import { getAvatarBgColor } from 'utility/helpers';

type ProfileAvatarProps = {
  isLoggedInUser: boolean;
  user: UserType;
  showUploadIcon?: boolean;
};

function ProfileAvatar({ isLoggedInUser, user, showUploadIcon = true }: ProfileAvatarProps) {
  const [profileModalOpen, setProfileModalOpen] = useState(false);

  return (
    <>
      <IconButton onClick={() => setProfileModalOpen(true)} sx={{ p: 0 }}>
        <Badge
          overlap="circular"
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          badgeContent={
            isLoggedInUser && showUploadIcon ? (
              <BadgeContentContainer>
                <Upload2LineIcon size={20} />
              </BadgeContentContainer>
            ) : null
          }
          sx={{ ml: 0 }}
        >
          <Avatar
            src={user.profileImageURL}
            sx={(theme) => ({
              backgroundColor: user?.userNameToDisplay
                ? getAvatarBgColor(user?.userNameToDisplay, 30, 50)
                : theme.palette.secondary.dark,
              width: 100,
              height: 100,
              fontSize: 64,
            })}
          >
            {user?.userNameToDisplay ? (
              user?.userNameToDisplay?.slice(0, 1)?.toUpperCase()
            ) : (
              <UserLineIcon size={60} />
            )}
          </Avatar>
        </Badge>
      </IconButton>
      {profileModalOpen && (
        <UpdateProfilePhotoModal
          isLoggedInUser={isLoggedInUser}
          user={user}
          open={profileModalOpen}
          setOpen={setProfileModalOpen}
          profileImageURL={user?.profileImageURL}
        />
      )}
    </>
  );
}

const BadgeContentContainer = styled(Box, { label: 'BadgeContentContainer' })(({ theme }) => ({
  borderRadius: '50%',
  padding: 6,
  backgroundColor: theme.palette.custom.white,
  boxShadow: '0px 2.90909px 2.90909px rgba(0, 0, 0, 0.25)',
}));

export default ProfileAvatar;
